import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { createQueueNodeAttributes } from 'components/powerFlowShared/components/nodeTypes/canvas/queue';
import { FlowType } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { QueueModal } from '../../modals';
export const QueueNodeAutomationAttributes = Object.assign(Object.assign({}, createQueueNodeAttributes(FlowType.FLOW_TYPE_AUTOMATION)), { translateScopeVariables: undefined, translatePayload: () => [], updateConnection: (node) => node, NodeContent: QueueNode, ActionModal: QueueModal });
export function QueueNode({ node }) {
    const { payload } = node;
    const { queueName } = payload;
    return (_jsx(TextContent, { children: useMemo(() => (_jsx(TextEllipsis, { children: _jsx(Text, { weight: "semibold", text: queueName !== null && queueName !== void 0 ? queueName : 'Re-offer' }) })), [queueName]) }));
}
